(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/tables/assets/javascripts/views/statgeneraltables.js') >= 0) return;  svs.modules.push('/components/statistics/tables/assets/javascripts/views/statgeneraltables.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatGeneralTables = svs.statistics.views.SportserviceTabBase.extend(
    {
      logger: new svs.core.log.Logger('svs.statistics.views.StatGeneralTables'),

      tagName: 'div',

      classId: 'StatGeneralTables',

      events: {
        'change #underlyingLeaguesFilter': 'selectMenu',
        'change #leagueTableFilter': 'selectMenu',
        'change #leagueHomeAwayFilter': 'selectMenu',
        'change #leagueTypeFilter': 'selectMenu'
      },

      initialize: function(options) {
        this.leagueId = 0;
        this.sportId = 0;
        this.options = options;

        if (this.model) {
          this.model.destroy();
        }

        options = options || {};
        svs.statistics.views.SportserviceTabBase.prototype.initialize.apply(
          this,
          [options]
        );

        var preloadedModels = '',
          leagueIds;
        if (this.options.params.leagueId) {
          if (!this.options.params.teamId && !this.options.params.matchId) {
            if (
              this.options.params.league &&
              this.options.params.league instanceof svs.statistics.models.League
            ) {
              this.leagueModel = this.options.params.league;
            } else if (!this.leagueModel) {
              this.leagueModel = new svs.statistics.models.League({
                leagueId: this.options.params.leagueId
              });
              this.leagueModel.fetch();
              this.leagueModel.on('change', this.leagueModelLoaded, this);
              return;
            }
            preloadedModels = 'leagueModels';
            this.leagueId = this.leagueModel.get('league').id;
            this.sportId = this.leagueModel.get('league').sport.id;
            this.model = new svs.statistics.models.StatGeneralTables({
              leagueId: this.options.params.leagueId,
              league: this.leagueModel.get('league'),
              preloaded: preloadedModels
            });
          } else {
            leagueIds = [];
            if (
              svs.utils.ns.isNamespace('params.currentLeagues', this.options)
            ) {
              _.each(
                this.options.params.currentLeagues.get('leagues'),
                function(league) {
                  leagueIds.push(league.id);
                }
              );
            } else if (
              svs.utils.ns.isNamespace('params.leagueId', this.options)
            ) {
              leagueIds.push(this.options.params.leagueId);
            }
            if (
              svs.utils.ns.isNamespace(
                'statistics.data.teamModels.leaguetables',
                svs
              )
            ) {
              preloadedModels = 'teamModels';
            } else if (
              svs.utils.ns.isNamespace(
                'statistics.data.matchModels.leaguetables',
                svs
              )
            ) {
              preloadedModels = 'matchModels';
            } else {
              preloadedModels = 'leagueModels';
            }
            this.model = new svs.statistics.models.StatGeneralTables({
              leagueId: this.options.params.leagueId,
              leagueIds: leagueIds,
              teamId: this.options.params.teamId,
              preloaded: preloadedModels
            });
          }
        } else if (this.options.params.leagues) {
          leagueIds = [];
          _.each(this.options.params.leagues.leagueTables, function(league) {
            leagueIds.push(league.leagueId);
          });
          this.model = new svs.statistics.models.StatGeneralTables({
            leagueTables: this.options.params.leagues,
            leagueIds: leagueIds
          });
          preloadedModels = 'teamModels';
        }
        this.filters = this.createFilters();

        if (!this.model) {
          return;
        }

        this.model.set('match', this.options.params.match);

        this.model.on('change', this.render, this);
        var _self = this;
        this.model.on('fetchError', function() {
          _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
          _self.$('.js-statistics-reload').bind('click', function() {
            $(this).unbind('click');
            _self.update();
          });
        });

        this.listenTo(
          this.model,
          'liveMatchesFetched',
          this.onLiveMatchesFetched
        );
        this.listenTo(this.model, 'isLiveTable', this.onLiveMatchesFetched);

        if (
          svs.utils.ns.isNamespace(
            'statistics.data.' + preloadedModels + '.leaguetables',
            svs
          ) &&
          !svs.statistics.data[preloadedModels].leaguetables.error
        ) {
          this.render(options);
        } else {
          this.update(options);
        }
      },

      onLiveMatchesFetched: function() {
        this.render();
      },

      leagueModelLoaded: function() {
        if (this.leagueModel) {
          this.leagueModel.off('change');
        }
        this.listenTo(
          this.model,
          'liveMatchesFetched',
          this.onLiveMatchesFetched
        );
        this.listenTo(this.model, 'isLiveTable', this.onLiveMatchesFetched);
        this.initialize();
      },

      update: function() {
        this.model.doFetch();
      },

      renderWithData: function() {
        var _self = this,
          componentFile = 'stat-general-table',
          theme;

        if (svs.utils.ns.isNamespace('attributes.error', this.model)) {
          if (this.model.attributes.error.code === 404) {
          } else {
            _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
            _self.$('.js-statistics-reload').bind('click', function() {
              $(this).unbind('click');
              _self.update();
            });
            return this;
          }
        }

        if (svs.utils.ns.isNamespace('attributes.leagueTables', this.model)) {
          if (_.isObject(this.model.attributes.leagueTables[0])) {
            if (_.isObject(this.model.attributes.leagueTables[0].sport)) {
              this.leagueId = this.model.attributes.leagueTables[0].leagueId;
              this.sportId = this.model.attributes.leagueTables[0].sport.id;
            }
          }
        }

        if (!this.model) {
          this.$el.html(
            svs.statistics.statistics.templates.nodata({
              renderEmpty: this.options.params.preDraw
            })
          );
          return this;
        }
        if (!this.leagueId || !this.sportId) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
          return this;
        }

        theme = new svs.sport.themeLoader({
          sport: _self.sportId,
          league: _self.leagueId
        });
        theme.load(function(template) {
          _self.template = template;
        }, componentFile);

        if (!this.template) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
          return this;
        }

        this.$el.html(
          svs.statistics.tables.templates.statgeneraltableholder(
            this.applyFilters()
          )
        );
        if (
          Object.prototype.hasOwnProperty.call(this.options.params, 'parent')
        ) {
          this.options.params.parent.trigger('resize');
        }
        return this;
      },

      selectMenu: function(event) {
        var selected = $(event.currentTarget);
        var selectedVal = selected.val();

        if (svs.core.detect.formfactor.mobile()) {
          selected.trigger('blur');
        }

        this.filters[
          $(event.currentTarget).attr('id')
        ].selectedKey = selectedVal;
        _.each(
          this.filters[$(event.currentTarget).attr('id')].filterValues,
          function(filterValue) {
            filterValue.selected = false;
          }
        );
        this.filters[$(event.currentTarget).attr('id')].filterValues[
          selectedVal
        ].selected = true;

        if (event.currentTarget.name === 'underlyingLeaguesFilter') {
          this.resetFilters();
          this.filters.leagueTableFilter = {
            filterValues: {},
            selectedKey: '',
            showDropDown: false
          };
          var leagueId = selectedVal.split('_')[1];
          this.model.setCurrentLeague(leagueId);
        } else if (event.currentTarget.name === 'leagueTableFilter') {
          if (this.filters.leagueTypeFilter.selectedKey !== 'Normal') {
            this.resetFilters();
            this.model.setSelection('Normal');
          } else {
            this.resetFilters();
            this.render({});
          }
        } else if (event.currentTarget.name === 'leagueTypeFilter') {
          this.model.setSelection(selectedVal);
        } else {
          this.render({});
        }
      },

      createFilters: function() {
        var normalName = 'Full tid',
          isLive = false,
          homeAwayFilter = {
            filterValues: {
              total: { name: 'Alla', selected: true },
              home: { name: 'Hemma', selected: false },
              away: { name: 'Borta', selected: false }
            },
            selectedKey: 'total',
            showDropDown: true
          };
        var filters = {
          underlyingLeaguesFilter: {
            filterValues: {},
            selectedKey: '',
            showDropDown: false
          },
          leagueTableFilter: {
            filterValues: {},
            selectedKey: '',
            showDropDown: false
          },
          leagueHomeAwayFilter: homeAwayFilter,
          leagueTypeFilter: {
            filterValues: {
              Normal: { name: normalName, selected: true, isLive: isLive },
              HalfTime: { name: 'Halvtid', selected: false },
              SecondHalfTime: { name: '2:a halvlek', selected: false },
              Form: { name: 'Form', selected: false }
            },
            selectedKey: 'Normal',
            showDropDown: true
          },
          leagueTableShowLegend: false
        };
        return filters;
      },

      resetFilters: function() {
        var normalName = 'Full tid',
          isLive = false,
          homeAwayFilter = {
            filterValues: {
              total: { name: 'Alla', selected: true },
              home: { name: 'Hemma', selected: false },
              away: { name: 'Borta', selected: false }
            },
            selectedKey: 'total',
            showDropDown: true
          };
        this.filters.leagueHomeAwayFilter = homeAwayFilter;
        this.filters.leagueTypeFilter = {
          filterValues: {
            Normal: { name: normalName, selected: true, isLive: isLive },
            HalfTime: { name: 'Halvtid', selected: false },
            SecondHalfTime: { name: '2:a halvlek', selected: false },
            Form: { name: 'Form', selected: false }
          },
          selectedKey: 'Normal',
          showDropDown: true
        };
        this.filters.leagueTableShowLegend = false;
      },

      isShowHomeAwayTables: function() {
        var showHomeAwayDropdownForTable = true;

        new svs.sport.themeLoader({
          sport: this.sportId,
          league: this.leagueId
        }).load(function(template, init) {
          if (init) {
            showHomeAwayDropdownForTable = init('isShowHomeAwayTables');
          }
        }, 'stat-general-table');

        return showHomeAwayDropdownForTable;
      },

      applyFilters: function() {
        var leagues = this.model.get('leagueTables'),
          transitionLegend = {},
          _self = this;

        if (
          svs.utils.ns.isNamespace('components.theme.data.mapping.sport', svs)
        ) {
          if (
            this.sportId !==
            _.invert(svs.sport.theme.data.mapping.sport)['sport-soccer']
          ) {
            delete this.filters.leagueTypeFilter.filterValues.HalfTime;
            delete this.filters.leagueTypeFilter.filterValues.SecondHalfTime;
          }
        }

        if (
          svs.utils.ns.isNamespace('components.theme.data.mapping.league', svs)
        ) {
          if (
            this.leagueId ===
            _.invert(svs.sport.theme.data.mapping.league)['league-nhl']
          ) {
            delete this.filters.leagueTypeFilter.filterValues.Form;
            this.filters.leagueTypeFilter.showDropDown = false;
          }
        }
        this.filters.leagueHomeAwayFilter.showDropDown = this.isShowHomeAwayTables();

        var isFirst = true,
          keyName,
          leagueName;

        if (_.size(this.filters.underlyingLeaguesFilter.filterValues) < 1) {
          isFirst = true;
          _.each(this.model.underlyingLeagues, function(league) {
            keyName = 'id_' + league.id;
            _self.filters.underlyingLeaguesFilter.filterValues[keyName] = {
              name: league.name,
              selected: isFirst
            };
            if (isFirst) {
              _self.filters.underlyingLeaguesFilter.selectedKey = keyName;
              isFirst = false;
            } else {
              _self.filters.underlyingLeaguesFilter.showDropDown = true;
            }
          });
        }

        if (_.size(this.filters.leagueTableFilter.filterValues) < 1) {
          leagues = _.sortBy(leagues, function(league) {
            return league.name;
          });
          leagues = _.sortBy(leagues, function(league) {
            return -league.tableRows.length;
          });

          isFirst = true;

          _.each(leagues, function(league) {
            keyName = league.name;
            leagueName = league.name;
            if (league.league) {
              if (league.league.name !== league.league.uniqueLeagueName) {
                leagueName = league.league.name;
              }
            }
            _self.filters.leagueTableFilter.filterValues[keyName] = {
              name: leagueName,
              selected: isFirst
            };
            if (isFirst) {
              _self.filters.leagueTableFilter.selectedKey = keyName;
              isFirst = false;
            } else {
              _self.filters.leagueTableFilter.showDropDown = true;
            }
          });
        }

        leagues = _.filter(leagues, function(league) {
          return league.name === _self.filters.leagueTableFilter.selectedKey;
        });

        var match = this.model.get('match'),
          isSortSelectionForm = this.model.get('selection') === 'Form',
          isHomeAwaySelected =
            ['home', 'away'].indexOf(
              this.filters.leagueHomeAwayFilter.selectedKey
            ) >= 0;
        _.each(leagues, function(league) {
          league.tableRows =
            isSortSelectionForm && isHomeAwaySelected
              ? _self._sortArrayMultipleColumns(
                league.tableRows,
                _self.filters.leagueHomeAwayFilter.selectedKey,
                true,
                'points',
                'goalDiff'
              )
              : _self._sortArrayMultipleColumns(
                league.tableRows,
                _self.filters.leagueHomeAwayFilter.selectedKey,
                false,
                'sortPosition'
              );
          _.each(league.tableRows, function(tableRow) {
            tableRow.rowData =
              tableRow[_self.filters.leagueHomeAwayFilter.selectedKey];
            if (_self.options.params.teamId) {
              tableRow.boldTeam =
                tableRow.teamId === _self.options.params.teamId;
            } else if (match) {
              if (match.homeTeam) {
                tableRow.boldTeam =
                  tableRow.teamId === match.homeTeam.id ||
                  tableRow.teamId === match.awayTeam.id;
              } else {
                tableRow.boldTeam =
                  tableRow.teamId === match.participants[0].id ||
                  tableRow.teamId === match.participants[1].id;
              }
            }
            var transitionName;
            if (tableRow.transitionInfo) {
              transitionName = tableRow.transitionInfo;
            } else {
              transitionName = 'EMPTY';
            }
            transitionLegend[transitionName] = {};
          });
          league.template = _self.template;
        });

        this.filters.leagueTableShowLegend =
          this.filters.leagueHomeAwayFilter.selectedKey === 'total';

        var transitionName,
          color = 0,
          countBy = +1,
          iterator = 0;
        for (var t in transitionLegend) {
          if (Object.prototype.hasOwnProperty.call(transitionLegend, t)) {
            transitionName = t;
            if (transitionName !== 'EMPTY') {
              transitionLegend[t].color = color += countBy;
            } else {
              transitionLegend[t].color = 0;
              color = 0;
              countBy = -1;
            }
            iterator++;
            if (
              iterator === _.size(transitionLegend) &&
              iterator > 1 &&
              t !== 'EMPTY'
            ) {
              transitionLegend[t].color = -2;
            }
          }
        }

        _.each(leagues, function(league) {
          _.each(league.tableRows, function(tableRow) {
            if (tableRow.transitionInfo) {
              tableRow.transitionColor =
                _self.filters.leagueHomeAwayFilter.selectedKey === 'total'
                  ? transitionLegend[tableRow.transitionInfo].color
                  : 0;
            } else {
              tableRow.transitionColor = 0;
            }
          });
        });
        var isLive = this.model.isLiveTable(),
          selection = this.model.get('selection').toLowerCase();
        selection = isLive && selection === 'normal' ? 'live' : selection;
        return {
          leagueTables: leagues,
          filters: this.filters,
          transitionLegend: transitionLegend,
          selection: selection
        };
      },

      _sortArrayMultipleColumns: function(arr, sortCol, descSort) {
        var cols = Array.prototype.slice.call(arguments).slice(3);

        function compare(x, y, desc) {
          var cmp = !desc ? [1, -1] : [-1, 1];
          if (x === y) return 0;
          return x > y ? cmp[0] : cmp[1];
        }

        arr.sort(function(obj1, obj2) {
          var col, obj1val, obj2val;
          for (var i = 0; i <= cols.length; i++) {
            col = cols[i];
            obj1val = parseInt(obj1[sortCol][col], 10);
            obj2val = parseInt(obj2[sortCol][col], 10);
            if (obj1val !== obj2val) return compare(obj1val, obj2val, descSort);
          }
          return 0;
        });

        return arr;
      },

      onDestroy: function() {
        if (this.model) {
          this.model.off();
          this.model.clear(true);
          this.model.destroy();
          this.model = null;
          delete this.model;
        }

        delete this.options.params.parent;
        delete this.$el;
        delete this.el;
      }
    }
  );
})(Backbone, _, svs);

 })(window);